var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:!_vm._isMobile ? 'wrapperPcY' : ''},[_c('img',{attrs:{"src":require("../assets/image/yjey-1.jpg")}}),_vm._v(" "),_c('img',{attrs:{"src":require("../assets/image/yjey-2.jpg")}}),_vm._v(" "),_c('img',{attrs:{"src":require("../assets/image/yjey-3.jpg")}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ff4778e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/yjey.vue
// module id = null
// module chunks = 